import React from 'react';
import { Typography } from 'Components/atoms';
import SourcePill from 'Components/atoms/SourcePill/SourcePill';
import { sourceMeta } from '../InventoryGrid/sourceMeta';
import { TagFilterCaptionGroup } from './tagFilterUi.constants';
import '../InventoryGrid/styles.scss';
import { GoTag } from '@react-icons/all-files/go/GoTag';

interface TagFilterCollapsedCaptionProps {
    groups: TagFilterCaptionGroup[];
}

const TagFilterCollapsedCaption = ({ groups }: TagFilterCollapsedCaptionProps) => {
    if (groups.length === 0) {
        return null;
    }

    return (
        <div className="tag-filters-expandable__collapsed-caption">
            {groups.map((group) => (
                <div key={group.filterLabel} className="tag-filters-expandable__collapsed-row inventory-source-cell ">
                    <Typography variant="body5" className="tag-filters-expandable__collapsed-label mb-0">
                        {group.filterLabel}:
                    </Typography>
                    {group.tagNames.map((tagName) => {
                        const meta = sourceMeta(tagName);
                        return (
                            <SourcePill
                                key={tagName}
                                label={meta.label}
                                icon={<GoTag />}
                                tone={meta.tone}
                                title={tagName}
                            />
                        );
                    })}
                </div>
            ))}
        </div>
    );
};

export default TagFilterCollapsedCaption;
